module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumbs', {
    attrs: {
      "crumbs": [{
        name: 'Administrative Settings'
      }, {
        name: 'Form List',
        link: 'Form Builder Index'
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-title tabbable-line"
  }, [_vm._m(0), _vm._v(" "), (!_vm.isChildAccount) ? _c('ul', {
    staticClass: "nav nav-tabs"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        active: _vm.activeTab === tab.id
      },
      on: {
        "click": function($event) {
          return _vm.setActiveTab(tab.id)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": ("#" + (tab.id)),
        "data-toggle": "tab",
        "aria-expanded": "false"
      }
    }, [_vm._v("\n                " + _vm._s(tab.label) + "\n              ")])])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.isChildAccount) ? _c('p', [_vm._v("Changes to forms must be completed from Parent Account:\n          "), _c('strong', [(_vm.appUser.access > 5) ? _c('a', {
    attrs: {
      "href": this.$router.resolve({
        name: 'Manage Account Edit CaseMGR',
        params: {
          casemgrid: _vm.parentAccount.id
        }
      }).href
    }
  }, [_vm._v(_vm._s(_vm.parentAccount.name))]) : _c('span', [_vm._v(_vm._s(_vm.parentAccount.name))])])]) : _vm._e(), _vm._v(" "), (!_vm.isChildAccount) ? _c('div', {
    staticClass: "tab-content marginTop"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('div', {
      staticClass: "tab-pane",
      class: {
        active: _vm.activeTab === tab.id
      },
      attrs: {
        "id": tab.id
      }
    }, [(_vm.activeTab === tab.id) ? _c(tab.component, {
      tag: "component"
    }) : _vm._e()], 1)
  }), 0) : _vm._e()])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption caption-md"
  }, [_c('i', {
    staticClass: "icon-settings font-dark"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject font-dark sbold uppercase"
  }, [_vm._v("Form list")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f5d5340","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/FormBuilderIndex.vue
// module id = 1694
// module chunks = 1